module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8da626006f876af32c3df882283c44ec.png";